import { streamGroq, GroqMissingKeyError } from './groq-client';

export async function aiEnhanceBRD(brdMarkdown: string, onStream: (chunk: string) => void): Promise<void> {
  const system = `You are a senior business analyst. Polish this BRD: tighten requirement language (each requirement testable + measurable), add 2-3 missing requirements you'd expect, sharpen acceptance criteria into proper Given/When/Then form. Output the full enhanced BRD in Markdown.`;
  try {
    await streamGroq({ messages: [{ role: 'system', content: system }, { role: 'user', content: brdMarkdown }], temperature: 0.3, onStream });
  } catch (err) {
    if (err instanceof GroqMissingKeyError) { onStream('\n\n⚠️ No Groq API key set. Click the Settings gear ⚙ to add your free key. The pattern-based engine works fully without it.'); return; }
    onStream(`\n\n⚠️ ${err instanceof Error ? err.message : 'Groq error'}`);
  }
}
